/**
 * PMS Integration — directApiClient queries (LF-3214)
 */

'use client';

import { ActionResult } from '@/lib/types/actions';
import { PmsStatus } from './types';
import { directApiClient } from '@/lib/api/direct-client';

export async function getPmsStatus(): Promise<ActionResult<PmsStatus>> {
  try {
    const data = await directApiClient.get<PmsStatus>(
      '/customer-integrations/pms/status'
    );
    return { success: true, data };
  } catch (error) {
    const statusCode =
      error && typeof error === 'object' && 'status' in error
        ? (error as { status?: number }).status
        : undefined;
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to fetch PMS status',
      ...(statusCode ? { statusCode } : {})
    };
  }
}
